import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useDeleteStanding = () => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (standingId: string) => {
      return await request(`${sport}/o/${organizationId}/standings/${standingId}`, { method: "DELETE" });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (isDefaultOperationSucceeded(response)) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId],
        });
      }
    },
  });
};
